/** The 3D heatmap's box. Shared by the canvas and the poster that stands in for
 *  it until the three.js chunk loads, so swapping one for the other moves
 *  nothing on the page. Lives apart from ModeHeatmapCanvas so the poster can
 *  use it without importing three. */
export const HEATMAP_STAGE_CLASS =
  'h-[320px] w-full rounded-lg border border-[var(--app-border)] overflow-hidden bg-[var(--rt-page)]';
